import { useState } from "react";
import emailjs from "@emailjs/browser";
import Header from './Header';

export default function Partner() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    interest: "Investor",
    message: "",
    link: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Email to user
      await emailjs.send(
        "service_f055kya",
        "template_tyqomhc",
        {
          to_email: form.email,
          full_name: form.fullName,
          interest_type: form.interest,
        },
        "FeJD_kM1e0tvi4MfV"
      );

      // Email to admin
      await emailjs.send(
        "service_f055kya",
        "template_8j3x5nu",
        {
          admin_email: "youremail@example.com",
          full_name: form.fullName,
          email: form.email,
          interest_type: form.interest,
          message: form.message,
          link: form.link || "N/A",
        },
        "FeJD_kM1e0tvi4MfV"
      );

      alert("Message sent successfully!");

      setForm({
        fullName: "",
        email: "",
        interest: "Investor",
        message: "",
        link: "",
      });
    } catch (err) {
      console.error(err);
      alert("Failed to send message.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="partner-div">
      <Header/>

      <h2 className="appear">Join Us & Invest in the Future of Luxury Commerce</h2>
      <p className="appear">Ready to invest? Invest through Wefunder    Looking to join as a co-founder? Apply via Y Combinator   Otherwise, use the form below to reach out for partnerships or other opportunities.</p>
      <form
        onSubmit={handleSubmit}
        className="glass-form partner-form appear"
        style={{
        maxWidth: 560,
        padding: 24,
        borderRadius: 12,
        border: "1px solid rgb(111, 109, 109)",
        }}
      >
        <label>Full Name</label>
        <input
          name="fullName"
          placeholder="Full Name"
          value={form.fullName}
          onChange={handleChange}
          required
        />

        <label>Email Address</label>
        <input
          name="email"
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />

        {/* Dropdown aligned right */}
        <label>I'm interested as </label>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            height: "35px",
          }}
        >
          <select
            name="interest"
            value={form.interest}
            onChange={handleChange}
          >
            <option value="Investor">Investor</option>
            <option value="Co-Founder">Co-Founder</option>
            <option value="Partner / Other">Partner / Other</option>
          </select>
        </div>

        <label>Message</label>
        <textarea
          name="message"
          placeholder="Tell us about your interest and how you'd like to contribute..."
          value={form.message}
          onChange={handleChange}
          required
          rows={5}
          style={{
            resize: "none",
          }}
        />

        <label>LinkedIn or Website (Optional)</label>
        <input
          name="link"
          placeholder="https://linkedin.com/in/yourprofile or https://yourwebsite.com"
          value={form.link}
          onChange={handleChange}
        />

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: 12,
            marginTop: 24,
            cursor: loading ? "not-allowed" : "pointer",
            border: "none",
            borderRadius: 7,
          }}
          className="header-download"
        >
          {loading ? "Sending..." : "Send Message"}
        </button>
    </form>
    </div>
    
  );
}